import { z } from 'zod/v4-mini';
import { subscriptionProcedure } from '../trpc/common.js';
import { observable } from '@trpc/server/observable';
import type { ApiParams } from '../types/ApiParams.js';
import { ZodGetDataInput, type GetDataInput } from './getData.js';

/**
 * Provides a way to subscribe to any data changes in the data bus.
 */
export function onDataChanged(params: ApiParams<GetDataInput, 'bus'>): unknown {
  const {
    input: { path },
    ctx: { bus },
  } = params;

  return observable((emit) =>
    bus.subscribe(path, (value) => {
      emit.next(value);
    }),
  );
}

// Attach a trpc procedure to the function.
onDataChanged.procedure = subscriptionProcedure<GetDataInput, unknown>(onDataChanged, ZodGetDataInput, z.unknown());
